import styled from 'styled-components/macro';

export const PremiumPurchaseContainer = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${props => props.theme.colors.transparent};
`;
